import { useRef } from 'react';
import type { ReactNode } from 'react';
import useTranslation from 'next-translate/useTranslation';

// Components
import Modal from '@/components/base/Modal';
import Button from '@/components/base/Button';

type ConfirmationModalProps = {
    isOpen: boolean;
    onSubmit: () => void;
    closeModal: () => void;
    isLoading?: boolean;
    title: string;
    children: ReactNode;
};

export const ConfirmationModal = ({
    isOpen,
    onSubmit,
    closeModal,
    isLoading,
    title,
    children
}: ConfirmationModalProps) => {
    const initialFocus = useRef<HTMLButtonElement>(null);
    const { t } = useTranslation('commons');

    return (
        <Modal open={isOpen} onDismiss={closeModal} initialFocus={initialFocus} className="!z-100">
            <Modal.Body>
                <Modal.Title>{title}</Modal.Title>
                <Modal.Content className="pt-m text-center font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {children}
                </Modal.Content>
                <Modal.Footer
                    className="flex flex-col items-center justify-between space-y-3 pb-12 pt-8 xs:flex-row xs:space-x-3 xs:space-y-0"
                    divider={false}>
                    <Button
                        variant="secondary"
                        className="w-full"
                        ref={initialFocus}
                        onClick={closeModal}
                        disabled={isLoading}>
                        {t('no')}
                    </Button>
                    <Button onClick={onSubmit} className="w-full" isLoading={isLoading}>
                        {t('yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationModal;
